import { zReplace } from './zReplace';

export function getOrgFirstName(orgName: string) {
  return zReplace(orgName, '[^a-zA-Z0-9가-힣]|\\([주\\s]*\\)')?.substr(0, 1);
}
